import React, {Component} from 'react';
import {connect} from 'react-redux';
// utils
import {Translations} from '../../../utils';
// constant
import {FORM_REFS} from '../../../constants';
// restClient
import {aemHostClient, eapiClient} from '../../../restClient';
// children
import Dynamicform from '../../common/Dynamicform/dynamicForm';
import {blockUi, unBlockUi} from '../../../actions/actionCreator';

class CreateACHCredits extends Component{
  constructor(props){
    super(props);
    this.state={};
  }

  componentWillMount(){
    let apiURL = "/aemData/formData/json_add-ach-credit-page";
    this.props.blockUi();
    aemHostClient(apiURL)
    .then(({data}) => {
      document.title = `${Translations(data.par.aemform_addAchCreditPage.title,this.props.lang.currentLang.lang, this.props.lang.translatedData)} - ${'HSBC GLCM'}`
      this.setState({formJson: data});
      this.props.unBlockUi();
    });
  }

  getFormData = (formData) => {
    this.setState({formData});
  }

  onFormSubmit = (event, apiUrl) => {
    this.props.blockUi();
    const caseId = this.state.formData.entity ? (this.state.formData.entity.value) : undefined;
    var requestData = {...this.state.formData};
    requestData.caseId = caseId;
    eapiClient(apiUrl, {
      method: 'POST',
      data: JSON.stringify(requestData)
    })
    .then(({data}) => {
      this.props.history.goBack();
      this.props.unBlockUi();
    });
  }

  onFormCancel = () => {
    this.props.history.goBack();
  }

  renderFormGroups(){
    let formData = {};
      const properties = {
      caseId: this.props.match.params.caseId,
      formData,
      editType: 'add-ach-to-case',
      pathname: this.props.history.location.pathname
    };
    if(this.state.formJson !== undefined && this.state.formJson.par.aemform_addAchCreditPage !== undefined){
      return (
        <Dynamicform mode={this.props.mode}
        properties={properties}
        url={FORM_REFS[this.state.formJson.par.aemform_addAchCreditPage.formRef]}
        getFormData={this.getFormData}
        onFormSubmit={this.onFormSubmit}
        onFormCancel={this.onFormCancel}
        lang = {this.props.lang.currentLang.lang}
        translatedData ={this.props.lang.translatedData}
        flag={this.props.lang.currentLangFlag.flag}
        achCreditProductList = {this.props.achCreditProductList}
        />
      );
    }
  }

  render(){
    const pageTitle = this.state.formJson ? this.state.formJson.par.aemform_addAchCreditPage : '';
    return(
      <div className="form-container">
      <div className="form-title">
      <h2 className="form-heading">
        {Translations(pageTitle.title,this.props.lang.currentLang.lang, this.props.lang.translatedData)}
      </h2>
      <p className="form-required-desc">
        {Translations(pageTitle.description,this.props.lang.currentLang.lang, this.props.lang.translatedData)}
      </p>
      </div>
      {this.renderFormGroups()}
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    lang: state.lang,
    achCreditProductList: state.productDetails.achCredit
  }
}

const mapDispatchToProps = dispatch => {
  return {
    blockUi: () => {
      dispatch(blockUi())
    },
    unBlockUi: () => {
      dispatch(unBlockUi())
    }
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(CreateACHCredits);



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CreateACHCredits.js